export const CLIENT_PARTY_TYPES = {
  INTERNAL: 'Internal',
  EXTERNAL: 'External'
};

export const getClientPartyTypeName = (clientType) => {
  switch (clientType) {
    case CLIENT_PARTY_TYPES.INTERNAL:
      return 'Internal';
    case CLIENT_PARTY_TYPES.EXTERNAL:
      return 'External';
    default:
      return clientType;
  }
};

export const getClientPartyTypeBackgroundColor = (clientType) => {
  switch (clientType) {
    case CLIENT_PARTY_TYPES.INTERNAL:
      return '#E0F2FE';
    case CLIENT_PARTY_TYPES.EXTERNAL:
      return '#FFE8CC';
    default:
      return '#F3F4F6';
  }
};

export const getClientPartyTypeTextColor = (clientType) => {
  switch (clientType) {
    case CLIENT_PARTY_TYPES.INTERNAL:
      return '#0369A1';
    case CLIENT_PARTY_TYPES.EXTERNAL:
      return '#CC5500';
    default:
      return '#6B7280';
  }
};